import { bootstrap } from '@vendor/js/theme/bootstrap';
import { Spinner } from '@vendor/js/spinner';
import { Swal } from '@vendor/libs/sweetalert2/sweetalert2';
import { Api } from '@vendor/js/api';
import Common from '@vendor/js/common';
const _MessagesCommonHandler = (function () {
    const setupPreviewModalHandler = (url) => {
        const modalElement = document.getElementById(`preview_message_modal`);
        $('body').on('click', '[data-bs-target="#preview_message_modal"]', async function () {
            if (modalElement != null) {
                let modal = bootstrap.Modal.getInstance(modalElement);
                let id = $(this).data('app-id');
                let spinner = new Spinner();
                let getMessageUrl = url.replace('ID', id);
                try {
                    const response = await Api.get(getMessageUrl);
                    if (response.success) {
                        const message = response.data.message;
                        $(modalElement).find('[data-app-content]').html(message.content);
                        spinner.destroy();
                    }
                    else {
                        let dataMessage = 'Wystąpił błąd podczas próby załadowania danych.';
                        Swal.fire({
                            text: dataMessage,
                            icon: 'error',
                            buttonsStyling: false,
                            reverseButtons: true,
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'btn btn-primary',
                            },
                        }).then(() => {
                            if (modal != null) {
                                modal.hide();
                            }
                        });
                    }
                }
                catch (err) {
                    Common.handleErrorResponse(err);
                }
                finally {
                    spinner.destroy();
                }
            }
            else {
                console.log('Modal not found');
            }
        });
    };
    return {
        // Public functions
        setupPreviewModalHandler,
    };
})();
window.MessagesCommonHandler = _MessagesCommonHandler;
